import { Record } from './models/record';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { ExtractService } from './extract.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Util } from '../../utils/util';
import { BankExtract } from './extract.model';
import { FilterTypePeriod } from '../pix/models/filter-type-period.enum';

@Component({
	selector: 'app-extract',
	templateUrl: './extract.component.html',
	styleUrls: ['./extract.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ExtractComponent implements OnInit {

	public extractRecords: Array<Record> = [];
	public extractRecordsComplete: Array<Record> = [];
	public noRecordsMessage = 'Não há registros para este período.';
	public dateBegin: Date;
	public dateEnd: Date;
	public subtitle: string;
	public showBalance = true;
	public togglePix = false;
	public togglePixRefund = false;
	public filterTypePeriodSelected = FilterTypePeriod.NONE;
	public futureReleases = false; // Devemos verificar esses campos
	public loading = true; // Devemos verificar esses campos

	constructor(
		private route: ActivatedRoute,
		private extractService: ExtractService
	) {
		this.listenRoute();
	}

	ngOnInit() {
	}

	listenRoute() {
		this.route.params.subscribe(params => {
			if (this.route.routeConfig.data.byDays) {
				const daysRoute = this.route.routeConfig.data.days as number;
				this.setFilter(daysRoute);
				this.dateBegin = Util.DateAddDay(-daysRoute);
				this.dateEnd = null;
				this.subtitle = this.getSubtitle(daysRoute === 0);

				this.getList();
			}

			if (this.route.routeConfig.data.byMonth && params.month) {
				const monthIndex = params.month - 1;
				const lastDayOfMonth = moment(params.year + '-' + params.month, 'YYYY/MM').daysInMonth();
				this.dateBegin = moment({ year: params.year, month: monthIndex, day: 1}).toDate();
				this.dateEnd = moment({ year: params.year, month: monthIndex, day: lastDayOfMonth}).toDate();
				const subtitleDate = new Date(params.year + '-' + (parseInt(params.month, 10)) + '-' + '03');
				this.subtitle = 'Mês: ' + moment(subtitleDate).locale('pt-BR').format('MMMM') + ' de ' + params.year;
				this.filterTypePeriodSelected = FilterTypePeriod.CUSTOM;

				this.getList();
			}
		});
	}

	setFilter(days: number) {
		switch (days) {
			case 0:
				this.filterTypePeriodSelected = FilterTypePeriod.TODAY;
				break;
			case 15:
				this.filterTypePeriodSelected = FilterTypePeriod.BIWEEKLY;
				break;
			case 30:
				this.filterTypePeriodSelected = FilterTypePeriod.MONTHLY;
				break;
		}
	}

	onSelectedCustomPeriod(data: any) {
		if (data) {
			this.dateBegin = data.dateBegin ? data.dateBegin : Util.DateAddDay(-14);
			this.dateEnd = data.dateEnd ? data.dateEnd : null;
			this.subtitle = this.getSubtitle(Util.isToday(data.dateBegin));
			this.getList();
		}
	}

	getList() {
		const dateBegin = moment(this.dateBegin).format('YYYY-MM-DD');
		const dateEnd = this.dateEnd ? moment(this.dateEnd).format('YYYY-MM-DD') : null;

		this.extractService.getNewExtract(dateBegin, dateEnd, true).subscribe(result => {
			if (result.Sucesso && result.Existe) {
				this.extractRecords = [];
				const items = Util.keysToCamel(result.Retorno) as BankExtract;
				this.extractRecords = this.extractService.convertModelToView(items);
			}
		});
	}

	changeTogglePix() {
		if (this.togglePix) {
			this.extractRecordsComplete = this.extractRecords;
			this.extractRecords = this.extractRecords.filter(o => o.isPix);
		} else {
			this.togglePixRefund = false;
			this.extractRecords = this.extractRecordsComplete;
		}
	}

	changeTogglePixRefund() {
		if (this.togglePixRefund) {
			this.extractRecords = this.extractRecords.filter(o => o.isPixDevolution);
		} else {
			this.extractRecords = this.extractRecordsComplete.filter(o => o.isPix);
		}
	}

	private getSubtitle(isToday: boolean) {
		const subtitleDateEnd = this.dateEnd ? this.dateEnd : new Date();
		return isToday
			? `Hoje, ${moment().locale('pt-BR').format('DD')} de ${moment().locale('pt-BR').format('MMMM')}`
			: `Periodo: ${moment(this.dateBegin).format('DD/MM/YYYY')} à ${moment(subtitleDateEnd).format('DD/MM/YYYY')}`;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/extract/extract.component.ts